import type { IStudioTabPrNoticeMarqueeConfig } from '../StudioTabPrNoticeMarquee';
import type { IStudioTabInfoConfig } from '../StudioQueryTabs/types';

export interface IInfluencerTabLogConfig {
  enabled?: boolean;
  pageId?: string;
  pageName?: string;
  extInfo?: string;
  pagePath?: string;
}

export interface IInfluencerTabConfig {
  key: string;
  nameEn: string;
  nameCn: string;
  /** 与 compConfig 注册的组件 name 一致 */
  name: string;
  componentProps?: Record<string, unknown>;
  logConfig?: IInfluencerTabLogConfig;
  /** Tab 级跑马灯；未配置或 textEn/textZh 均为空时不展示 */
  prNoticeMarquee?: IStudioTabPrNoticeMarqueeConfig;
  /** Tab 栏右侧 info；show 为 true 时展示 */
  info?: IStudioTabInfoConfig;
}

export interface IInfluencerWrapperConfig {
  queryKey?: string;
  defaultTab?: string;
  titleEn?: string;
  titleCn?: string;
  descriptionEn?: string;
  descriptionCn?: string;
  tabs: IInfluencerTabConfig[];
}

/** Studio Influencer 各 Tab 共用的筛选器实例 ID（Tab 间继承，离开/刷新不继承） */
export const STUDIO_INFLUENCER_FILTER_INSTANCE_ID = 'studio-influencer';
